import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "sidebarComponent", "headerComponent", "sidebarBackgroundColor"];
import styled, { useTheme } from 'foundations-theming/utils';
import { AbstractPageTemplate } from '../AbstractPageTemplate';
import { rgba } from '../../utils/color';
import { SidebarPageContext } from './SidebarPageProvider';
import { NAV_BAR_HEIGHT } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
export const SidebarInner = styled.div.withConfig({
  displayName: "SidebarPage__SidebarInner",
  componentId: "sc-1nf0j14-0"
})(({
  $sidebarBackgroundColor,
  theme
}) => {
  return {
    paddingBlockStart: theme.space['500'],
    paddingInline: theme.space['800'],
    overflowY: 'auto',
    backgroundColor: $sidebarBackgroundColor,
    minHeight: `calc(100vh - ${NAV_BAR_HEIGHT})`
  };
});
export const Main = styled.div.withConfig({
  displayName: "SidebarPage__Main",
  componentId: "sc-1nf0j14-1"
})(({
  theme
}) => {
  return {
    paddingBlock: theme.space['500'],
    paddingInline: theme.space['400'],
    '@media only screen and (max-width: 768px)': {
      paddingInline: theme.space['200']
    },
    '@media only screen and (max-width: 544px)': {
      paddingInline: theme.space['0']
    }
  };
});
export const SidebarPage = _ref => {
  let {
      children,
      sidebarComponent,
      headerComponent = null,
      sidebarBackgroundColor = 'fill-surface-raised'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const sidebarBackgroundColorValue = theme.color[sidebarBackgroundColor];
  const sidebarContent = /*#__PURE__*/_jsx(SidebarInner, {
    $sidebarBackgroundColor: sidebarBackgroundColorValue,
    children: sidebarComponent
  });
  const mainContent = /*#__PURE__*/_jsx(Main, {
    children: children
  });
  const abstractPageGridContentStylesOverrides = sidebarBackgroundColorValue !== theme.color['fill-transparent-default'] ? {
    backgroundColor: sidebarBackgroundColorValue,
    boxShadow: `1px 0 3px 0 ${rgba(theme.color['fill-accent-neutral-hover'], 0.25)}`,
    marginRight: theme.space['50'],
    [`@media only screen and (max-width: 544px)`]: {
      boxShadow: 'none',
      marginRight: theme.space['0']
    }
  } : {};
  return /*#__PURE__*/_jsx(SidebarPageContext.Provider, {
    value: {
      abstractPageGridContentStylesOverrides
    },
    children: /*#__PURE__*/_jsx(AbstractPageTemplate, Object.assign({
      "data-test-id": "sidebar-page",
      contentAreaFlush: true,
      sidebarAreaFlush: true,
      sidebarComponent: sidebarContent,
      pageLayout: "full-width",
      stickySidebar: true,
      headerComponent: headerComponent
    }, rest, {
      children: mainContent
    }))
  });
};